<header>
    <app-poll-header></app-poll-header>
</header>
<main>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</main>